import { handleActions } from 'redux-actions';
import * as actions from './actions';
import { resetForm } from "../create-llama/actions";

const defaultState = {
  currentDuration: null,
  originAudioPath: null,
  originAudioBlob: null,
};

const reducer = handleActions(
  new Map([
    [actions.setOriginAudio,
      (state, action) => ({
        ...state,
        originAudioPath: action.payload.uri,
        originAudioBlob: action.payload.blob
      })],
    [actions.setAudioDuration, (state, action) => ({ ...state, currentDuration: action.payload })],
    // on reset only audio
    [actions.resetAudioInfo, (state, action) => ({ ...defaultState })],
    // on reset form
    [resetForm, (state, action) => ({ ...defaultState })],
    [actions.restoreAudio, (state, action) => action.payload]


  ]),
  defaultState
);

export default reducer;


// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/media-audio/reducer.ts